import styled from 'styled-components';

const OrderTable = styled.div`
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    box-sizing: border-box;
    border-radius: 8px;
`;

export default OrderTable;
